import React, { useState } from 'react';
import Select from 'react-select';
import { LineGraph } from './charts/LineGraph';
import Spinner from './spinner/Spinner';
import useFetchData from '../hooks/useFetchData';
import useFetchAnalytics from '../hooks/useFetchAnalytics';

export default function SponsoredCohortLoginAnalytics() {
  const [cohortId, setCohortId] = useState('');
  const [cohortName, setCohortName] = useState('');
  const [interval, setInterval] = useState('');

  // get cohorts
  const { data: cohorts } = useFetchData(
    ['cohorts'],
    '/cohorts',
    {},
    "Couldn't get cohorts. Please try again!",
    true
  );

  const cohortOptions = cohorts
    ? cohorts?.data?.cohorts?.map((cohort) => ({
        value: cohort.id,
        label: cohort.name,
      }))
    : [];

  const intervalOptions = [
    {
      value: 'daily',
      label: 'Daily',
    },
    {
      value: 'weekly',
      label: 'Weekly',
    },
    {
      value: 'monthly',
      label: 'Monthly',
    },
  ];

  const { data: cohortLogins, isLoading } = useFetchAnalytics(
    ['cohort-logins', cohortId, interval],
    `/${interval}-logins/${cohortId}`,
    {},
    "Couldn't get cohort logins. Please try again",
    cohortId && interval
  );

  return (
    <>
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm px-5 py-4">
        <p className="text-xs text-gray-500 leading-relaxed">
          <span className="block text-sm font-semibold text-gray-900 mb-1">
            Cohort Logins Analytics
          </span>
          <span className="block">
            Login statistics for learners, broken down by cohort
          </span>
        </p>
      </div>
      <div className="mt-4 grid grid-cols-4 gap-3 bg-white rounded-xl border border-gray-200 shadow-sm p-4">
        <Select
          isClearable
          placeholder="Select Cohort"
          className="react-dropdown"
          classNamePrefix="dropdown"
          options={cohortOptions}
          onChange={(event) => {
            setCohortId(event?.value || null);
            setCohortName(event?.label || null);
          }}
        />
        <Select
          isClearable
          placeholder="Select Interval"
          className="react-dropdown"
          classNamePrefix="dropdown"
          options={intervalOptions}
          onChange={(event) => {
            setInterval(event?.value || null);
          }}
        />
      </div>
      {isLoading && cohortId && interval ? (
        <div className="mt-4 flex items-center justify-center bg-white rounded-xl border border-gray-200 shadow-sm py-10">
          <Spinner />
        </div>
      ) : (
        <div className="mt-4 grid grid-cols-1 gap-2 bg-white rounded-xl border border-gray-200 shadow-sm p-4">
          <LineGraph
            title={
              cohortLogins?.data?.title ||
              `Student Logins ${cohortName ? `in ${cohortName}` : ''}`
            }
            colour="#8b173b"
            datasets={!cohortId ? [] : cohortLogins?.data?.datasets || []}
            labels={cohortLogins?.data?.labels}
            label="Number of learners"
          />
        </div>
      )}
    </>
  );
}
